import styled from 'styled-components';

import { Skeleton } from '@hivebrite/design-system/Skeleton';
import { useMeasure } from '@hivebrite/react-hooks';

import { WrapperCard } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCardLoader';

export const NewsPinnedLoader = () => {
  const [ref, , { height, width }] = useMeasure<HTMLDivElement>();

  return (
    <WrapperCard
      height={{ _: 146, m: 175, l: 210, xl: 221 }}
      ref={ref}
      width={{ _: 162, m: 226, l: 303, xl: 326 }}
    >
      {height && width && (
        <>
          <RoundedSkeleton width={width} />
          <TextSkeleton width={width - 32} />
          <TextSkeleton width={width - 32} />
        </>
      )}
    </WrapperCard>
  );
};

const RoundedSkeleton = styled(Skeleton).attrs({
  height: { _: 74, m: 103, l: 138, xl: 149 },
  isLarge: true,
  mb: 4,
})`
  border-radius: ${({ theme }) => {
    const br = theme.themeVariables.globalBorderRadius;

    return `${br}px ${br}px 0 0`;
  }};
`;

const TextSkeleton = styled(Skeleton).attrs({
  height: 12,
  isLarge: true,
  mx: 4,
  my: '10px',
})``;
